import gql from 'graphql-tag';

import featureFields from '@/queries/fields/featureFields';

const featuresActiveUntilFields = gql`
  fragment featuresActiveUntilFields on ActiveUntil {
    id
    activeUntil
    feature {
      ...featureFields
    }
  }
  ${featureFields}
`;

export default featuresActiveUntilFields;
